import { PageResult, WebshopWidgetListItemDto } from 'src/models/WebshopWidget';

export const getWebshopWidgets = async (): Promise<WebshopWidgetListItemDto[]> => {
  const response = await fetch(`/Widget`);

  const data = await response.json();

  return data;
};
